// ==============================|| LOGO ||============================== //

interface LogoProps {
  fullLogo: boolean;
  height: number;
}

const Logo = ({ fullLogo, height }: LogoProps) => {
  return (
    <img src={fullLogo ? "/logo.png" : "/favicon-196x196.png"} alt="Aigency" height={height} />
  );
};

export default Logo;
